import { render, staticRenderFns } from "./useApp.vue?vue&type=template&id=640d386f&"
import script from "./useApp.vue?vue&type=script&lang=js&"
export * from "./useApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports